import React from 'react';
import Alert from 'modules/shared/components/alert';
import classNames from 'classnames';

import './alert-discount-price-info.scss';

type paddings = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

interface AlertDiscountPriceInfoProps {
    paddingBottom?: paddings;
    paddingTop?: paddings;
}

const AlertDiscountPriceInfo: React.FC<AlertDiscountPriceInfoProps> = ({ paddingBottom = 0, paddingTop = 0 }) => (
    <div
        className={classNames({
            'alert-discount-price-info': true,
            [`alert-discount-price-info--pb-${paddingBottom}`]: paddingBottom > 0,
            [`alert-discount-price-info--pt-${paddingTop}`]: paddingTop > 0
        })}
    >
        <Alert color="info">
            Cena przekreślona jest najniższą ceną z ostatnich 30&nbsp;dni.
        </Alert>
    </div>
);

export default AlertDiscountPriceInfo;
